export function isObject(object: any): boolean {
    return object != null && typeof object === 'object';
};